import {
  Flex,
  Box,
  Table,
  Checkbox,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
  Button,
  Spinner,
  keyframes,
} from "@chakra-ui/react";
import React, { useEffect, useMemo, useState } from "react";
import {
  useGlobalFilter,
  usePagination,
  useSortBy,
  useTable,
} from "react-table";
import Divider from "@mui/material/Divider";
import DownloadIcon from "@mui/icons-material/Download";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
// Custom components
import Card from "components/card/Card";
import Menu from "components/menu/MainMenu";
import { CircularProgress } from "@mui/material";
import { formatPrice } from "utils/format";

const blink = keyframes`
  0%, 100% { background-color: #3F06FF; }
  50% { background-color: #8EDDBE; }
`;

export default function ServiceTable(props) {
  const {
    columnsData,
    tableData,
    onClickCategory,
    onClickBuy,
    onClickPrice,
    onClickDetail,
    onClickDownload,
    loading,
    friend,
    justPurchasedId,
  } = props;
  // const [activeMenu, setActiveMenu] = useState('profiling');
  // const [serviceData, setServiceData] = useState([]);
  const columns = useMemo(() => columnsData, [columnsData]);
  const data = useMemo(() => tableData, [tableData]);

  // useEffect(() => {
  //   if (data) {
  //     setServiceData(data.profiling)
  //   }
  // }, [data])

  // const onChangeMenu = menu => {
  //   if (menu === 'profiling') {
  //     setActiveMenu('profiling');
  //     setServiceData(data.profiling);
  //   } else if (menu === 'matching') {
  //     setActiveMenu('matching');
  //     setServiceData(data.matching);
  //   } else if (menu === 'persona') {
  //     setActiveMenu('persona');
  //     setServiceData(data.persona);
  //   }
  // }

  const handleDownload = ({ category, name, index }) => {
    onClickDownload({ category, name, index });
  };

  // const tableInstance = useTable(
  //   {
  //     columns,
  //     data,
  //   },
  //   useGlobalFilter,
  //   useSortBy,
  //   usePagination
  // );

  // const {
  //   getTableProps,
  //   getTableBodyProps,
  //   headerGroups,
  //   page,
  //   prepareRow,
  //   initialState,
  // } = tableInstance;
  // initialState.pageSize = 11;

  const textColor = useColorModeValue("secondaryGray.900", "white");
  const borderColor = useColorModeValue("gray.200", "whiteAlpha.100");
  return (
    <Card
      direction="column"
      w={{ md: "100%", lg: "80%" }}
      px="0px"
      overflowX={{ sm: "scroll", lg: "hidden" }}
    >
      <Flex flexDirection="column" gap={5}>
        <Flex flexDirection="column">
          <Flex gap={{ sm: 1, md: 30 }} flex={1} mb={2}>
            <Flex
              width={{ sm: "100%", md: "20%" }}
              borderColor="#059212"
              borderWidth={1}
              borderTopRadius={8}
              padding="5px 10px"
              backgroundColor={"#059212"}
            >
              <Text
                fontSize={{ sm: "xs", md: "sm" }}
                color={"#FFF"}
                fontWeight={"bold"}
              >
                PROFILING
              </Text>
            </Flex>
          </Flex>
          <Flex
            width="100%"
            gap={{ sm: 1, md: 5 }}
            backgroundColor={"#CADFB8"}
            borderTopRadius={8}
          >
            <Flex
              flex={{ sm: 3.5, md: 4.7 }}
              width="100%"
              borderTopRadius={8}
              padding="5px"
              backgroundColor={"#CADFB8"}
            >
              <Text
                color={"#000"}
                fontSize={{ sm: "xs", md: "sm" }}
                fontWeight="bold"
              >
                Type Profiling
              </Text>
            </Flex>
            <Flex
              flex={1.3}
              width="100%"
              borderTopRadius={8}
              padding="5px 10px"
              backgroundColor={"#CADFB8"}
            >
              <Text
                color={"#000"}
                fontSize={{ sm: "xs", md: "sm" }}
                fontWeight="bold"
              >
                Pricing
              </Text>
            </Flex>
            <Flex
              flex={1}
              width="100%"
              borderTopRadius={8}
              padding="5px 10px"
              backgroundColor={"#CADFB8"}
            >
              <Text
                color={"#000"}
                fontSize={{ sm: "xs", md: "sm" }}
                fontWeight="bold"
              >
                Action
              </Text>
            </Flex>
            <Flex
              flex={{ md: 5 }}
              display={{ base: "none", md: "flex" }}
              width="100%"
              borderTopRadius={8}
              padding="5px 10px"
              backgroundColor={"#CADFB8"}
            >
              <Text
                color={"#000"}
                fontSize={{ sm: "xs", md: "sm" }}
                fontWeight="bold"
              >
                Description
              </Text>
            </Flex>
          </Flex>
          <Flex width="100%" direction="column" gap={1} mt={1}>
            {data?.profiling.map((item, index) => {
              const isPurchase = data.profiling.find(
                (element) =>
                  element.name === item.name && element.isPurchase === true,
              );
              return (
                <Flex
                  direction="row"
                  width="100%"
                  gap={{ sm: 1, md: 2 }}
                  key={index}
                  alignItems="center"
                >
                  <Flex flex={0.1} width="100%">
                    <Text fontSize={{ sm: "xs", md: "sm" }} color={"#000"}>
                      {index + 1}.
                    </Text>
                  </Flex>
                  <Flex flex={3.6} width="100%">
                    <Text
                      fontWeight={700}
                      fontSize={{ sm: "xs", md: "sm" }}
                      color={"#000"}
                    >
                      {item.name}{" "}
                      {item.duration &&
                        `${item.duration} ${item.duration_type}`}
                    </Text>
                  </Flex>
                  <Flex flex={1.3} width="100%">
                    {item.isPurchase ? (
                      <Text
                        flex={1}
                        fontSize={{ sm: "xs", md: "sm" }}
                        minWidth={{ sm: "50px", md: "100px" }}
                      >
                        Sudah beli
                      </Text>
                    ) : (
                      <Text
                        cursor="pointer"
                        textDecoration="underline"
                        flex={1}
                        fontSize={{ sm: "xs", md: "sm" }}
                        minWidth={{ sm: "50px", md: "100px" }}
                        onClick={() =>
                          onClickPrice({
                            category: item.category,
                            service: "profiling",
                          })
                        }
                      >
                        Rp {formatPrice(item.price)}
                      </Text>
                    )}
                  </Flex>
                  <Flex flex={{ base: 1, md: 1 }} width="100%" paddingX="20px" pr={{ base: "0", md: "20px" }}>
                    {item.isPurchase || isPurchase ? (
                      <Flex flexDirection="row" width="100%" gap={1}>
                        <Flex flex={1}>
                          {item.type === "profiling" ? (
                            <Button
                              id={
                                item.id === justPurchasedId
                                  ? "blinking-button"
                                  : undefined
                              }
                              width={"60px"}
                              bgColor={
                                item.id === justPurchasedId
                                  ? "#8EDDBE"
                                  : "green.800"
                              }
                              color="white"
                              fontSize={{ sm: "xs", md: "sm" }}
                              fontWeight="500"
                              borderRadius={"5px"}
                              border={
                                item.id === justPurchasedId
                                  ? "0px solid #6C8003"
                                  : undefined
                              }
                              padding="0px 15px"
                              animation={
                                item.id === justPurchasedId
                                  ? `${blink} 1s linear infinite`
                                  : undefined
                              }
                              onClick={() =>
                                handleDownload({
                                  category: item.category,
                                  service: "profiling",
                                  name: item.features,
                                  index: index,
                                })
                              }
                              title="Download PDF"
                              _hover={{
                                bgColor:
                                  item.id === justPurchasedId
                                    ? "#8EDDBE"
                                    : "green.800",
                              }}
                              _active={{
                                bgColor:
                                  item.id === justPurchasedId
                                    ? "#8EDDBE"
                                    : "green.800",
                              }}
                            >
                              {loading[index] ? (
                                <CircularProgress
                                  thickness={4}
                                  size={15}
                                  sx={{
                                    color: (theme) =>
                                      theme.palette.grey[
                                        theme.palette.mode === "light"
                                          ? 200
                                          : 800
                                      ],
                                  }}
                                />
                              ) : (
                                "Unduh"
                              )}
                            </Button>
                          ) : (
                            <Button
                              width="60px"
                              bgColor="green"
                              color="white"
                              fontSize={{ sm: "xs", md: "sm" }}
                              fontWeight="500"
                              borderRadius="5px"
                              onClick={() =>
                                onClickCategory({
                                  category: item.category,
                                  service: item.type,
                                  name: item.features,
                                })
                              }
                              px="5px"
                              py="10px"
                              title="Open Web View"
                            >
                              <OpenInNewIcon fontSize="sm" />
                            </Button>
                          )}
                        </Flex>
                      </Flex>
                    ) : (
                      <Flex flex={1}>
                        <Button
                          width="60px"
                          bgColor="green"
                          color="white"
                          fontSize={{ sm: "xs", md: "sm" }}
                          fontWeight="500"
                          borderRadius="5px"
                          onClick={() =>
                            onClickBuy({
                              category: item.category,
                              service: "profiling",
                              name: item.name,
                              id: item.id,
                            })
                          }
                          px="15px"
                          py="0px"
                        >
                          Beli
                        </Button>
                      </Flex>
                    )}
                  </Flex>
                  <Flex
                    flex={{ md: 5 }}
                    display={{ base: "none", md: "flex" }}
                    width="100%"
                  >
                    <Text fontSize={{ sm: "xs", md: "sm" }} color={"#000"}>
                      {item.desc}
                    </Text>
                  </Flex>
                </Flex>
              );
            })}
          </Flex>
        </Flex>
        <Flex flexDirection="column">
          {!friend && (
            <>
              <Flex gap={{ sm: 1, md: 30 }} flex={1} mb={2}>
                <Flex
                  width={{ sm: "100%", md: "20%" }}
                  borderColor="#059212"
                  borderWidth={1}
                  borderTopRadius={8}
                  padding="5px 10px"
                  backgroundColor={"#059212"}
                >
                  <Text
                    fontSize={{ sm: "xs", md: "sm" }}
                    color={"#FFF"}
                    fontWeight={"bold"}
                  >
                    MATCHING
                  </Text>
                </Flex>
              </Flex>
              <Flex
                width="100%"
                gap={{ sm: 1, md: 5 }}
                backgroundColor={"#CADFB8"}
                borderTopRadius={8}
              >
                <Flex
                  flex={4.7}
                  width="100%"
                  borderTopRadius={8}
                  padding="5px"
                  backgroundColor={"#CADFB8"}
                >
                  <Text
                    color={"#000"}
                    fontSize={{ sm: "xs", md: "sm" }}
                    fontWeight="bold"
                  >
                    Type Matching
                  </Text>
                </Flex>
                <Flex
                  flex={1.3}
                  width="100%"
                  borderTopRadius={8}
                  padding="5px 10px"
                  backgroundColor={"#CADFB8"}
                >
                  <Text
                    color={"#000"}
                    fontSize={{ sm: "xs", md: "sm" }}
                    fontWeight="bold"
                  >
                    Subscription
                  </Text>
                </Flex>
                <Flex
                  flex={{ base: 1, md: 1 }}
                  width="100%"
                  borderTopRadius={8}
                  padding="5px 10px"
                  backgroundColor={"#CADFB8"}
                >
                  <Text
                    color={"#000"}
                    fontSize={{ sm: "xs", md: "sm" }}
                    fontWeight="bold"
                  >
                    Action
                  </Text>
                </Flex>
                <Flex
                  flex={{ md: 5 }}
                  display={{ base: "none", md: "flex" }}
                  width="100%"
                  borderTopRadius={8}
                  padding="5px 10px"
                  backgroundColor={"#CADFB8"}
                >
                  <Text
                    color={"#000"}
                    fontSize={{ sm: "xs", md: "sm" }}
                    fontWeight="bold"
                  >
                    Description
                  </Text>
                </Flex>
              </Flex>
              <Flex width="100%" direction="column" gap={1} mt={1}>
                {data?.matching.map((item, index) => {
                  return (
                    <Flex flexDirection="column" gap="2px">
                      <Flex
                        direction="row"
                        width="100%"
                        gap={{ sm: 2, md: 2 }}
                        key={index}
                        alignItems="center"
                      >
                        <Flex flex={0.1} width="100%">
                          <Text
                            fontSize={{ sm: "xs", md: "sm" }}
                            color={"#000"}
                          >
                            {index + 1}.
                          </Text>
                        </Flex>
                        <Flex flex={{base: 4.6, md: 1}} width="100%">
                          <Text
                            fontWeight={700}
                            fontSize={{ sm: "xs", md: "sm" }}
                            color={"#000"}
                          >
                            {item.type.split(" ")[0]}:
                          </Text>
                        </Flex>
                        <Flex
                          flex={{base: 1.3, md: 0.5}}
                          width="100%"
                          minWidth={{ sm: "65px", md: "120px" }}
                        ></Flex>
                        <Flex
                          flex={1}
                          display={{ base: "none", md: "flex" }}
                          width="100%"
                          paddingX="20px"
                          paddingInlineEnd={0}
                        >
                          <Text
                            fontSize={{ sm: "xs", md: "sm" }}
                            color={"#000"}
                          >
                            {item.desc}
                          </Text>
                        </Flex>
                      </Flex>
                      {item.data.map((match, i) => {
                        const isPurchase = item.data.find(
                          (element) => element.isPurchase === true,
                        );
                        return (
                          <Flex
                            direction="row"
                            width="100%"
                            gap={{ sm: 1, md: 2 }}
                            key={i}
                            alignItems="center"
                          >
                            <Flex flex={4.7} width="100%">
                              <Text
                                textTransform="capitalize"
                                fontWeight={700}
                                textAlign="end"
                                width="100%"
                                pl={{ sm: 5, md: 20 }}
                                fontSize={{ sm: "xs", md: "sm" }}
                                color={"#000"}
                              >
                                {match.duration} {match.duration_type === "day" ? "Hari" : match.duration_type}
                              </Text>
                            </Flex>
                            <Flex flex={1.3} width="100%">
                              {isPurchase ? (
                                <Text
                                  flex={1}
                                  fontSize={{ sm: "xs", md: "sm" }}
                                  minWidth={{ sm: "50px", md: "100px" }}
                                >
                                  Sudah beli
                                </Text>
                              ) : (
                                <Text
                                  cursor="pointer"
                                  textDecoration="underline"
                                  flex={1}
                                  fontSize={{ sm: "xs", md: "sm" }}
                                  minWidth={{ sm: "50px", md: "100px" }}
                                  onClick={() =>
                                    onClickPrice({
                                      category: match.category,
                                      service: "matching",
                                    })
                                  }
                                >
                                  Rp {formatPrice(match.price)}
                                </Text>
                              )}
                            </Flex>
                            <Flex
                              flex={{ base: 1, md: 1 }}
                              width="100%"
                              paddingX="20px"
                              paddingInlineEnd={0}
                            >
                              {isPurchase ? (
                                <Flex flexDirection="row" width="100%" gap={1}>
                                  <Flex flex={1}>
                                    <Button
                                      width="60px"
                                      bgColor="green"
                                      color="white"
                                      fontSize={{ sm: "xs", md: "sm" }}
                                      fontWeight="500"
                                      borderRadius="5px"
                                      onClick={() =>
                                        onClickCategory({
                                          category: match.category,
                                          service: match.type,
                                          name: match.features,
                                        })
                                      }
                                      px="5px"
                                      py="5px"
                                      title="Open Web View"
                                    >
                                      <OpenInNewIcon fontSize="sm" />
                                    </Button>
                                  </Flex>
                                </Flex>
                              ) : (
                                <Flex flex={1}>
                                  <Button
                                    width="60px"
                                    bgColor="green"
                                    color="white"
                                    fontSize={{ sm: "xs", md: "sm" }}
                                    fontWeight="500"
                                    borderRadius="5px"
                                    onClick={() =>
                                      onClickBuy({
                                        category: match.category,
                                        service: "matching",
                                        name: match.name,
                                        id: match.id,
                                      })
                                    }
                                    px="15px"
                                    py="0px"
                                  >
                                    Beli
                                  </Button>
                                </Flex>
                              )}
                            </Flex>
                            <Flex
                              flex={{ md: 5 }}
                              display={{ base: "none", md: "flex" }}
                              width="100%"
                            ></Flex>
                          </Flex>
                        );
                      })}
                      <Flex></Flex>
                    </Flex>
                  );
                })}
              </Flex>
            </>
          )}
        </Flex>
        <Flex flexDirection="column">
          <Flex gap={{ sm: 1, md: 30 }} flex={1} mb={2}>
            <Flex
              width={{ sm: "100%", md: "20%" }}
              borderColor="#059212"
              borderWidth={1}
              borderTopRadius={8}
              padding="5px 10px"
              backgroundColor={"#059212"}
            >
              <Text
                fontSize={{ sm: "xs", md: "sm" }}
                color={"#FFF"}
                fontWeight={"bold"}
              >
                PERSONA
              </Text>
            </Flex>
          </Flex>
          <Flex
            width="100%"
            gap={{ sm: 1, md: 5 }}
            backgroundColor={"#CADFB8"}
            borderTopRadius={8}
          >
            <Flex
              flex={4.7}
              width="100%"
              borderTopRadius={8}
              padding="5px"
              backgroundColor={"#CADFB8"}
            >
              <Text
                color={"#000"}
                fontSize={{ sm: "xs", md: "sm" }}
                fontWeight="bold"
              >
                Type Persona
              </Text>
            </Flex>
            <Flex
              flex={1.3}
              width="100%"
              borderTopRadius={8}
              padding="5px 10px"
              backgroundColor={"#CADFB8"}
            >
              <Text
                color={"#000"}
                fontSize={{ sm: "xs", md: "sm" }}
                fontWeight="bold"
              >
                Subscription
              </Text>
            </Flex>
            <Flex
              flex={1}
              width="100%"
              borderTopRadius={8}
              padding="5px 10px"
              backgroundColor={"#CADFB8"}
            >
              <Text
                color={"#000"}
                fontSize={{ sm: "xs", md: "sm" }}
                fontWeight="bold"
              >
                Action
              </Text>
            </Flex>
            <Flex
              flex={{ md: 5 }}
              display={{ base: "none", md: "flex" }}
              width="100%"
              borderTopRadius={8}
              padding="5px 10px"
              backgroundColor={"#CADFB8"}
            >
              <Text
                color={"#000"}
                fontSize={{ sm: "xs", md: "sm" }}
                fontWeight="bold"
              >
                Description
              </Text>
            </Flex>
          </Flex>
          <Flex width="100%" direction="column" gap={1} mt={1}>
            <Flex
              direction="row"
              width="100%"
              gap={{ sm: 3, md: 2 }}
              alignItems="center"
            >
              <Flex
                flex={4.7}
                width="100%"
                minWidth={{ sm: "110px", md: "120px" }}
              >
                <Text
                  fontWeight={700}
                  fontSize={{ sm: "xs", md: "sm" }}
                  color={"#000"}
                >
                  1. Persona:
                </Text>
              </Flex>
              <Flex
                flex={1.3}
                width="100%"
                minWidth={{ sm: "65px", md: "120px" }}
              ></Flex>
              <Flex
                flex={{ base: 1, md: 1 }}
                width="100%"
                paddingX="20px"
              ></Flex>
              <Flex
                flex={{ md: 5 }}
                display={{ base: "none", md: "flex" }}
                width="100%"
              >
                <Text fontSize={{ sm: "xs", md: "sm" }} color={"#000"}>
                  Persona General, dapat dilihat di web
                </Text>
              </Flex>
            </Flex>

            {data?.persona.map((item, index) => {
              const isPurchase = data.persona.find(
                (element) => element.isPurchase === true,
              );
              return (
                <Flex
                  direction="row"
                  width="100%"
                  gap={{ sm: 1, md: 2 }}
                  key={index}
                  alignItems="center"
                >
                  <Flex flex={5} width="100%">
                    <Text
                      pl={{ sm: 5, md: 20 }}
                      textTransform="capitalize"
                      fontWeight={700}
                      width="100%"
                      textAlign="end"
                      fontSize={{ sm: "xs", md: "sm" }}
                      color={"#000"}
                    >
                      {item.duration &&
                        `${item.duration} ${item.duration_type === "day" ? "Hari" : item.duration_type}`}
                    </Text>
                  </Flex>
                  <Flex flex={1.3} width="100%">
                    {isPurchase ? (
                      <Text
                        flex={1}
                        fontSize={{ sm: "xs", md: "sm" }}
                        minWidth={{ sm: "50px", md: "100px" }}
                      >
                        Sudah beli
                      </Text>
                    ) : (
                      <Text
                        cursor="pointer"
                        textDecoration="underline"
                        flex={1}
                        fontSize={{ sm: "xs", md: "sm" }}
                        minWidth={{ sm: "50px", md: "100px" }}
                        onClick={() =>
                          onClickPrice({
                            category: item.category,
                            service: "persona",
                          })
                        }
                      >
                        Rp {formatPrice(item.price)}
                      </Text>
                    )}
                  </Flex>
                  <Flex flex={{ base: 1, md: 1 }} width="100%" paddingX="20px" pr={{ base: "0", md: "20px" }}>
                    {item.isPurchase || isPurchase ? (
                      <Flex flexDirection="row" width="100%" gap={1}>
                        <Flex flex={1}>
                          {item.type === "profiling" ? (
                            <Button
                              width="60px"
                              bgColor="green"
                              color="white"
                              fontSize={{ sm: "xs", md: "sm" }}
                              fontWeight="500"
                              borderRadius="5px"
                              onClick={() =>
                                handleDownload({
                                  category: item.category,
                                  service: "persona",
                                  name: item.features,
                                  index: index,
                                })
                              }
                              px="5px"
                              py="5px"
                              title="Download PDF"
                            >
                              {loading[index] ? (
                                <CircularProgress
                                  thickness={4}
                                  size={15}
                                  sx={{
                                    color: (theme) =>
                                      theme.palette.grey[
                                        theme.palette.mode === "light"
                                          ? 200
                                          : 800
                                      ],
                                  }}
                                />
                              ) : (
                                <DownloadIcon fontSize="sm" />
                              )}
                            </Button>
                          ) : (
                            <Button
                              width="60px"
                              bgColor="green"
                              color="white"
                              fontSize={{ sm: "xs", md: "sm" }}
                              fontWeight="500"
                              borderRadius="5px"
                              onClick={() =>
                                onClickCategory({
                                  category: item.category,
                                  service: item.type,
                                  name: item.features,
                                })
                              }
                              px="5px"
                              py="5px"
                              title="Open Web View"
                            >
                              <OpenInNewIcon fontSize="sm" />
                            </Button>
                          )}
                        </Flex>
                      </Flex>
                    ) : (
                      <Flex flex={1}>
                        <Button
                          width="60px"
                          bgColor="green"
                          color="white"
                          fontSize={{ sm: "xs", md: "sm" }}
                          fontWeight="500"
                          borderRadius="5px"
                          onClick={() =>
                            onClickBuy({
                              category: item.category,
                              service: "persona",
                              name: item.name,
                              id: item.id,
                            })
                          }
                          px="15px"
                          py="0px"
                        >
                          Beli
                        </Button>
                      </Flex>
                    )}
                  </Flex>
                  <Flex
                    flex={5}
                    width="100%"
                    display={{ base: "none", md: "flex" }}
                  >
                    {/* <Text fontSize={{ sm: 'xs', md: 'sm' }} color={'#000'}>{item.desc}</Text> */}
                  </Flex>
                </Flex>
              );
            })}
          </Flex>
        </Flex>
      </Flex>
    </Card>
  );
}
